import * as Sentry from "@sentry/angular";
import { bootstrapApplication } from '@angular/platform-browser';
import { formsBuilderAppConfig } from './app/app.config';
import { FormsBuilderAppComponent } from './app/app.component';
import {setAngularJSGlobal} from '@angular/upgrade/static';

Sentry.init({
  enabled: environment.sentryEnabled,
  dsn: environment.sentryDsn,
  sendDefaultPii: true,
  environment: environment.sentryEnv
});

import angular from 'angular';
import {environment} from './environments/environment';

setAngularJSGlobal(angular);

bootstrapApplication(FormsBuilderAppComponent, formsBuilderAppConfig)
  .catch((err) => console.error(err));
